module.exports = __webpack_public_path__ + "img/whatsapp.9c615a97.svg";